export const ROUTES = {
  HOME: '/home',
  USERNAME: '/home/:username',
};



// WEBPACK FOOTER //
// ./src/routes.js